const PW_SubmitButton = ({ disabled, children }) => (
  <button
    type="submit"
    disabled={disabled}
    className="inline-flex w-full items-center justify-center rounded-xl 
    bg-blue-500 px-5 py-3 text-sm font-semibold 
    text-white transition-colors hover:bg-blue-600
    focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-500/20 
    disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-blue-500"
  >
    {children}
  </button>
)

export default PW_SubmitButton
